import type { PresentationLibrary, QuoteFile } from 'paintscout'
import { shouldAddToLibrary } from '@paintscout/util/builder'

/**
 * Auto-adds files that reached a block directly — a drag/drop upload, a YouTube URL — to the
 * presentation library. Files picked through PresentationLibraryDialog are already in it and saved
 * by the dialog itself, so they never come through here; a second save would race that one.
 *
 * Returns the files it actually added, which is a subset: `shouldAddToLibrary` skips anything with
 * no library key (a YouTube entry has none) and anything already in the library.
 */
export function addNewFilesToLibrary(args: {
  files: QuoteFile[]
  presentationLibrary?: {
    addFilesToLibrary: (args: { files: QuoteFile[] }) => void
    library: PresentationLibrary
  }
}): QuoteFile[] {
  const { files, presentationLibrary } = args
  const { addFilesToLibrary, library } = presentationLibrary || {}

  if (!addFilesToLibrary || !files?.length) return []

  const newFiles = files.filter((file) => file && shouldAddToLibrary({ file, library }))

  if (!newFiles.length) return []

  addFilesToLibrary({ files: newFiles })

  return newFiles
}
